// import hasSampledVariantSelector from 'modules/variant/redux/selectors/has-sampled'

import loadByHandleProductAction from 'modules/product/redux/actions/load-by-handle'
import getByIdProductSelector from 'modules/product/redux/selectors/get-by-id'
import getDiscountedPriceVariantSelector from 'modules/variant/redux/selectors/get-discounted-price'
import logAddToCartConversionEventUtil from 'modules/cart/redux/actions/toggle-add-remove/actions/handle-add/utils/log-conversion-event'

/**
 * @param props
 * @param props.variantId
 * @param {ProductVariantCollection} props.productVariant
 * @returns {(function(*, *): Promise<undefined|{wasRemoved: *, wasAdded}>)|*}
 */
export default function logConversionEventHandleAddCartAction (props) {
  return async (dispatch, getState) => {
    const {
      variantId,
      productVariant
    } = props

    let product
    if (productVariant) {
      const productId = productVariant.product_id
      await dispatch(
        loadByHandleProductAction({
          handle: productVariant.handle,
          id: productId
        })
      )
      product = getByIdProductSelector(productId)(getState())
    }

    if (!product) {
      return
    }

    const price = productVariant.price
    const discountPrice = getDiscountedPriceVariantSelector({ variantId })(getState())
    logAddToCartConversionEventUtil({
      productVariant,
      price,
      product,
      discountPrice
    })
  }
}
